import { OrgApplication } from 'domain-types';

const normalizeText = (value?: string) => value?.trim() || '';

export const getApplicationHost = (url: string) => {
  try {
    return new URL(url).host.replace(/^www\./i, '');
  } catch (_error) {
    return url;
  }
};

export const getApplicationIconUrl = (application: OrgApplication) => {
  const configuredIconUrl = normalizeText(application.iconUrl);

  if (configuredIconUrl) {
    return configuredIconUrl;
  }

  try {
    return `${new URL(application.url).origin}/favicon.ico`;
  } catch (_error) {
    return '';
  }
};

export const getApplicationDisplayName = (application: OrgApplication) =>
  normalizeText(application.name) || getApplicationHost(application.url);

export const getApplicationDisplayDescription = (application: OrgApplication) =>
  normalizeText(application.description);

export const getApplicationInitials = (application: OrgApplication) =>
  getApplicationDisplayName(application)
    .split(/\s+/)
    .filter(Boolean)
    .slice(0, 2)
    .map((part) => part[0])
    .join('') || '?';
